<template>
    <div class="row card-body" style="padding-top: 0px;padding-bottom: 5em;" id="editFontFamily">
        <div class="card-header window-header" style="margin: 0px -10px 0px -10px; width: 105%;">
            <h4>{{ lang.eff_font_family }}</h4>
        </div>
        <div class="window-body">
            <div class="row" v-if="isLoading">
                <div class="col-md-12">
                    <div class="loadingImg">
                        <Loader></Loader>
                    </div>
                </div>
            </div>
            <form v-else class="row" @submit.prevent="submitFontFamily">
                <!-- Preview -->
                <div class="col-md-12">
                    <div class="font-preview-box">
                        <small class="preview-label">{{ lang.eff_preview }}</small>
                        <div class="font-preview" :style="previewStyle" ref="previewNameElement">
                            {{ previewName }}
                        </div>
                    </div>
                </div>

                <!-- Font selector -->
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="fontFamily">{{ lang.eff_select_font }}</label>
                        <select id="fontFamily" class="form-control" v-model="fontFamily" @change="onFontChange">
                            <option value="">{{ lang.eff_default }}</option>
                            <optgroup v-if="isTemplate7" :label="lang.eff_custom_fonts">
                                <option value="Autography">Autography</option>
                            </optgroup>
                            <optgroup :label="lang.eff_google_fonts">
                                <option v-for="font in googleFonts" :key="font.value" :value="font.value">{{ font.label }}</option>
                            </optgroup>
                        </select>
                    </div>
                </div>

                <!-- Actions -->
                <div class="col-md-12 marginTop text-center actionButtons">
                    <button
                        type="button"
                        class="btn btn-secondary btn-lg"
                        style="width: 110px; border-radius: 20px; margin-right: 10px;"
                        :disabled="isSubmitting"
                        @click="cancelEdit"
                    >
                        {{ lang.ec_cancel }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-success btn-lg"
                        style="width: 110px; border-radius: 20px;"
                        :disabled="isSubmitting"
                    >
                        {{ lang.ec_save }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import Loader from '../../../../../core/components/shared/Loader.vue';
import { mapGetters } from "vuex";
export default {
    name: "editFontFamily",
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            fontFamily: '',
            lang: {
                eff_font_family: '',
                eff_preview: '',
                eff_select_font: '',
                eff_default: '',
                eff_custom_fonts: '',
                eff_google_fonts: '',
                ec_cancel: '',
                ec_save: '',
                ec_fail: '',
                eff_fail_save_font: '',
            },
            googleFonts: [
                { label: 'Cinzel', value: 'Cinzel' },
                { label: 'Dancing Script', value: 'Dancing Script' },
                { label: 'Great Vibes', value: 'Great Vibes' },
                { label: 'Josefin Sans', value: 'Josefin Sans' },
                { label: 'Lato', value: 'Lato' },
                { label: 'Lobster', value: 'Lobster' },
                { label: 'Merriweather', value: 'Merriweather' },
                { label: 'Montserrat', value: 'Montserrat' },
                { label: 'Nunito', value: 'Nunito' },
                { label: 'Open Sans', value: 'Open Sans' },
                { label: 'Oswald', value: 'Oswald' },
                { label: 'Pacifico', value: 'Pacifico' },
                { label: 'Playfair Display', value: 'Playfair Display' },
                { label: 'Poppins', value: 'Poppins' },
                { label: 'PT Sans', value: 'PT Sans' },
                { label: 'Quicksand', value: 'Quicksand' },
                { label: 'Raleway', value: 'Raleway' },
                { label: 'Roboto', value: 'Roboto' },
                { label: 'Source Code Pro', value: 'Source Code Pro' },
                { label: 'Ubuntu', value: 'Ubuntu' },
            ],
            fontSizeFullName: 60,
        };
    },
    mounted() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        this.getFontFamily();
    },
    watch: {
        fontFamily() {
            this.$nextTick(() => { this.recalcFontSize(); });
        },
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            cardItem: "get_bsite_cardItem",
            langGetter: "lang",
        }),
        isTemplate7() {
            return this.cardItem && Number(this.cardItem.template_id) === 7;
        },
        previewName() {
            if (!this.cardItem) return 'Preview';
            return ((this.cardItem.name || '') + ' ' + (this.cardItem.lastname || '')).trim() || 'Preview';
        },
        previewStyle() {
            let style = {
                fontSize: this.fontSizeFullName + 'px',
                lineHeight: '1.4',
                transition: 'font-family 0.3s ease',
            };
            if (this.fontFamily) {
                style.fontFamily = `'${this.fontFamily}', sans-serif`;
            }
            return style;
        },
    },
    methods: {
        async recalcFontSize() {
            // Wait for the Google Font to finish loading before measuring
            if (this.fontFamily && this.fontFamily !== 'Autography') {
                try {
                    await document.fonts.load(`16px '${this.fontFamily}'`);
                } catch(e) { /* proceed anyway */ }
            }
            const el = this.$refs.previewNameElement;
            if (!el || !el.parentElement) {
                this.fontSizeFullName = 60;
                return;
            }
            const maxWidth = el.parentElement.offsetWidth;
            const maxSize = 60;
            const minSize = 14;
            const safetyGap = 16;
            let size = maxSize;
            // Temporarily drive el size so scrollWidth responds to each step
            el.style.fontSize = size + 'px';
            while (el.scrollWidth + safetyGap > maxWidth && size > minSize) {
                size--;
                el.style.fontSize = size + 'px';
            }
            el.style.fontSize = ''; // let Vue take over from fontSizeFullName
            this.fontSizeFullName = size;
        },
        loadGoogleFont(fontName) {
            if (!fontName || fontName === 'Autography') return;
            const id = 'gfont-' + fontName.replace(/\s+/g, '-').toLowerCase();
            if (document.getElementById(id)) return;
            const link = document.createElement('link');
            link.id = id;
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontName)}:wght@400;700&display=swap`;
            document.head.appendChild(link);
        },
        previewFont() {
            if (!this.cardItem) return;
            let previewItem = JSON.parse(JSON.stringify(this.cardItem));
            if (!Array.isArray(previewItem.temp_opts)) {
                previewItem.temp_opts = [];
            }
            let idx = previewItem.temp_opts.findIndex(opt =>
                opt.meta_key === 'font_family' && Number(opt.template_id) === Number(previewItem.template_id)
            );
            if (idx >= 0) {
                previewItem.temp_opts[idx].meta_value = this.fontFamily;
            }
        },
        onFontChange() {
            this.loadGoogleFont(this.fontFamily);
            this.previewFont();
            this.$nextTick(() => { this.recalcFontSize(); });
        },
        async getFontFamily() {
            let t = this;
            t.isLoading = true;
            // @ts-ignore
            window.master
                .post("getOptionsTemplate", {
                    // @ts-ignore
                    user_id: window.master_client,
                    // @ts-ignore
                    org_id: window.localorgdata,
                    template_id: t.cardItem.template_id,
                    id: t.cardItem.id,
                    meta_key: 'font_family',
                })
                .then(r => {
                    if (r.data.status && r.data.data && r.data.data.meta_value) {
                        t.fontFamily = r.data.data.meta_value;
                        t.loadGoogleFont(t.fontFamily);
                    }
                    t.isLoading = false;
                    t.$nextTick(() => { t.recalcFontSize(); });
                })
                .catch(error => {
                    console.log(error);
                    t.isLoading = false;
                });
        },
        cancelEdit() {
            this.$modal.hide("modal-editProfile");
        },
        async submitFontFamily() {
            let t = this;
            t.isSubmitting = true;
            try {
                let formData = new FormData();
                // @ts-ignore
                formData.append("user_id", window.master_client);
                // @ts-ignore
                formData.append("org_id", window.localorgdata);
                formData.append("id", t.cardItem.id);
                formData.append("template_id", t.cardItem.template_id);
                formData.append("meta_key", 'font_family');
                formData.append("meta_value", t.fontFamily);
                // @ts-ignore
                formData.append("pusher_id", window.pusher.connection.socket_id);
                await t.$store.dispatch('ModApps/Marketea/setTempOpts', formData);
                let previewItem = JSON.parse(JSON.stringify(this.cardItem));
                previewItem.temp_opts.push({
                    meta_key: 'font_family',
                    template_id: previewItem.template_id,
                    meta_value: this.fontFamily,
                });
                t.$store.commit('ModApps/Marketea/refreshPusherItem', previewItem);
                t.isSubmitting = false;
                t.$modal.hide("modal-editProfile");
            } catch (error) {
                console.log(error);
                t.isSubmitting = false;
                t.$notify({
                    group: "noti",
                    type: 'Error',
                    title: this.lang.ec_fail,
                    text: this.lang.eff_fail_save_font,
                    duration: 2500,
                });
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.window-header { cursor: move; }
.marginTop { margin-top: 20px; }
.card-header h4 { font-size: 24px; margin-bottom: 0px; }

.window-body {
    position: relative;
    width: 100%;
    margin: auto;
    height: 500px;
    border: 0px solid #000;
    margin-bottom: 2em;
    overflow: hidden;
    overflow-y: auto;
}

.font-preview-box {
    margin: 16px 0 20px;
    padding: 20px 16px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #f5f5f5;
    text-align: center;
}

.preview-label {
    display: block;
    color: #aaa;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 8px;
}

.font-preview {
    font-size: 40px;
    line-height: 1.4;
    color: #222;
    min-height: 44px;
    word-break: break-word;
}

.actionButtons {
    margin-bottom: 15px;
}
</style>
